export const RECEIVE_PLATFORMS = 'platforms/RECEIVE_PLATFORMS';
